import { RadioButton } from "primereact/radiobutton";
import { classNames as joinClassNames } from "primereact/utils";

import styles from "../../radio-group.module.scss";
import type { RadioGroupItemViewProps } from "./types-item";

export function RadioGroupItemView({
  label,
  labelId,
  description,
  descriptionId,
  disabled,
  classNames,
  rest,
  testId,
  partTestId,
  radioProps,
}: RadioGroupItemViewProps) {
  return (
    <div
      className={joinClassNames(styles.item, classNames?.item)}
      data-disabled={disabled || undefined}
      data-checked={radioProps.checked || undefined}
      data-testid={testId}
      {...rest}
    >
      <div className={joinClassNames(styles.control, classNames?.control)}>
        <RadioButton {...radioProps} data-testid={partTestId("radio")} />
        <label
          id={labelId}
          htmlFor={radioProps.inputId}
          className={joinClassNames(styles.label, classNames?.label)}
          data-testid={partTestId("label")}
        >
          {label}
        </label>
      </div>
      {description ? (
        <span
          id={descriptionId}
          className={joinClassNames(styles.description, classNames?.description)}
          data-testid={partTestId("description")}
        >
          {description}
        </span>
      ) : null}
    </div>
  );
}
